import React from 'react';
import { FadeIn } from './FadeIn';
export function CTASection() {
  return <section className="py-6 md:py-12 px-4 md:px-6 bg-navy text-cream text-center relative overflow-hidden" data-id="element-16">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-17"></div>

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-18">
        <FadeIn data-id="element-19">
          <h2 className="font-serif text-xl md:text-2xl text-gold mb-3 md:mb-5" data-id="element-20">
            Start Your Financial Reset
          </h2>
        </FadeIn>

        <FadeIn delay={200} data-id="element-21">
          <div className="space-y-2 text-sm md:text-base font-light text-cream/90" data-id="element-22">
            <p data-id="element-23">You don't need extreme budgeting.</p>
            <p data-id="element-24">You don't need another complicated spreadsheet.</p>
            <p data-id="element-25">
              You just need to understand the hidden psychology behind your
              spending habits.
            </p>
            <p className="mt-2 italic text-cream/60 text-xs md:text-sm" data-id="element-26">
              Once you see the program clearly… you can finally rewrite it.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}